export const getFaqList = (store) => store.faq.data;
export const getPaginationInfo = (store) => {
  const { data, ...rest } = store.faq;
  return rest;
};
export const getDoctorList = (store) => store.faq.filters.doctor;
